

export class ApprovalRequest {


    public vendorId: number;
    public approvalFlag: number;

     constructor(approvalRequest: any) {
         this.vendorId = approvalRequest.vendorId || '';
         this.approvalFlag = approvalRequest.approvalFlag || 1;
     }
 }
